module.exports = __webpack_public_path__ + "static/sc-08-ea999d7f8dba417177b67c5aa02cbd2d.png";